document.addEventListener('click', (e) => {
    if (!e.target.matches('[data-behaviour="child-toggle"]')) {
        return;
    }
    const toggle = e.target.matches('.is-active') ? 'remove' : 'add';

    e.target.classList[toggle]('is-active');
    e.target.nextElementSibling.classList[toggle]('is-active');
});
